import React, { useCallback } from 'react';

import isNumber from 'lodash/isNumber';
import range from 'lodash/range';

import ModalDropdown from '../../common/ModalDropdown/ModalDropdown';

import DaySelectionGrid from '../../DaySelectionGrid/DaySelectionGrid';

import { nthNumber } from '../../../utils/date_utils';

const DayGridDropdown = ({ values = [], onValuesSelected = () => {}, disabled = false }) => {
  const renderModal = useCallback(() => (
    <DaySelectionGrid
      values={values}
      onValuesSelected={onValuesSelected}
    />
  ), [values, onValuesSelected])

  const displayRange = range(0, 4);
  const displayValues = displayRange.map(index => values[index]).filter(val => isNumber(val));
  const hasMore = values.length > displayRange.length;

  const dropdownLabel = `${displayValues.map(nthNumber).join(',')}${hasMore ? '...' : ''}`;

  return (
    <ModalDropdown
      renderModal={renderModal}
      dropdownLabel={dropdownLabel}
      menuWidth="288px"
      isDisabled={disabled}
    />
  )
}

export default DayGridDropdown;
